import { Clickable, Col, Icon, Row, Text } from 'components';
import { useInfiniteScroll } from 'core';
import { Api } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Header, ProductPanel } from 'screens/Admin/components';
import { Filters, List } from './components';

const Products = ({}) => {
  const [dataId, setDataId] = useState(null),
    [owner, setOwner] = useState(null),
    [loading, setLoading] = useState(false),
    products = useSelector((state) => state.admin.products),
    fetching = useRef(false),
    skip = useRef(0),
    dispatch = useDispatch(),
    scrollId = 'admin-products-list';

  useEffect(() => {
    skip.current = products?.length || 0;
  }, [products]);

  useEffect(() => {
    skip.current = 0;
    setLoading(true);

    getProducts(true);
  }, [owner]);

  useInfiniteScroll(scrollId, getProducts);

  async function getProducts(isInitial) {
    if (fetching.current) return;
    fetching.current = true;

    const res = await Api.post('/admin/getProducts', {
      skip: skip.current || 0,
      ownerId: owner?._id
    });
    if (!res) return (fetching.current = false);

    dispatch({
      type: owner || isInitial ? 'ADMIN_SET_PRODUCTS' : 'ADMIN_ADD_PRODUCTS',
      payload: res
    });

    fetching.current = false;
    setLoading(false);
  }

  function handleSelect(postId) {
    setDataId(postId);
  }

  return (
    <Col noFlex wid="100%" ht="100vh" start>
      <Header>
        <Row center>
          <Text h3>Products</Text>

          <Clickable onClick={() => setDataId(true)}>
            <Icon marg="0 0 0 8px" type="add" dimensions={18} />
          </Clickable>
        </Row>
      </Header>

      <Col start noFlex marg="54px 0 0" wid="100%" ht="100vh" id={scrollId} scrollY>
        <Filters owner={owner} setOwner={setOwner} className="filters" />

        <List data={products} dataId={dataId} onClick={handleSelect} loading={loading} />
      </Col>

      <ProductPanel dataId={dataId} setDataId={setDataId} closeModal={() => setDataId(null)} />
    </Col>
  );
};

export default Products;
